import { NavLink, useNavigate } from "react-router-dom";
import { _put } from "../../../../apiClient";
import { _showToast } from "../../../../toastHelper";
import { useAuth } from "../../../Context/store/context";
import { useSelector } from "react-redux";

export default function Theme(props) {
  const { showLoader, hideLoader, setThemeJsonData } = useAuth();
  const navigate = useNavigate();
  const invitations = useSelector((state) => state.invitations.invitations);

  const changeThemeHandler = async (e, themeId) => {
    e.preventDefault();
    let response = await callUpdateApi(themeId);

    if (response && response != "") {
      let event = invitations.filter((x) => x.id == props.eventId);

      if (event && event.length > 0) {
        window.open(event[0].eventUrl, "_blank");
      }

      if (props.isForWebsite && props.profileUrl && props.profileUrl != "") {
        window.open(props.profileUrl, "_blank")
      }
      return !props.isForDemo && !props.isForWebsite
        ? navigate("/invitations")
        : props.isForWebsite
          ? navigate("/website/" + props.profileId)
          : navigate("/demos");
    }
  };

  const callUpdateApi = async (themeId) => {
    showLoader();
    let changeUrl = props.eventId
      ? "/events/change-theme"
      : props.profileId
        ? "/profile-pages/change-theme"
        : "";

    let id = props.eventId ?? props.profileId;

    return await _put(changeUrl, {
      id: id,
      themeId: themeId,
    })
      .then((response) => {
        hideLoader();
        _showToast("Theme updation successfully completed", "success");
        return response;
      })
      .catch((error) => {
        hideLoader();
        _showToast(error, "error");
        return "";
      });
  };

  const createInvitationHandler = () => {
    const url = "/create-invitation/" +
      props.theme.categoryCode +
      "/" +
      props.theme.categoryId +
      "/" +
      props.theme.id;
    setThemeJsonData(props.theme.themeJson);
    navigate(url);
  }


  return (
    <div className="col-md-6 col-xl-3" key={props.theme.id}>
      <div className="feat_property">
        <div className="thumb">
          <img className="img-whp" src={props.theme.thumbnailPath} />
        </div>
        <div className="details text-center">
          <div className="tc_content">
            <h4 className="mb-3 text-dark">{props.theme.name}</h4>
            <a
              className="btn btn-sm btn-secondary px-2 mb-3 me-3"
              href={props.theme.previewHtmlPath}
              target="_blank"
            >
              <span className="align-middle">Preview Theme</span>
            </a>
            {!props.eventId &&
              !props.profileId &&
              !props.isForDemo &&
              !props.isForWebsite && (
                <a onClick={createInvitationHandler}
                  className="btn btn-sm btn-primary px-2 mb-3">
                  <span className="align-middle text-white">
                    Select & Proceed
                  </span>
                </a>
              )}

            {(props.eventId || props.profileId) && (
              <button
                className="btn btn-sm btn-primary px-2 mb-3"
                onClick={(e) => changeThemeHandler(e, props.theme.id)}
              >
                <span className="align-middle text-white">
                  Change & Preview
                </span>
              </button>
            )}

            {!props.eventId && !props.profileId && props.isForDemo && (
              <NavLink
                to={"/create-demo/" + props.theme.id}
                className="btn btn-sm btn-primary px-2 mb-3"
              >
                <span className="align-middle text-white">
                  Select & Proceed
                </span>
              </NavLink>
            )}
            {!props.eventId && !props.profileId && props.isForWebsite && (
              <NavLink
                to={"/create-website/" + props.theme.id}
                className="btn btn-sm btn-primary px-2 mb-3"
              >
                <span className="align-middle text-white">
                  Select & Proceed
                </span>
              </NavLink>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
